module.exports = __webpack_public_path__ + "assets/img/news (42).2d615ba1.png";